import React from 'react';

import { LinearProgress } from '@mui/material';

import CabinFormsDataGrid from '../../components/CabinFormsDataGrid';

import { useGetCabinEventSubmissions } from '../../core/api/hooks/cabin-event';
import { EventFormStatus, ReportType } from '../../core/api/clients';
import useGetEventReportsByType from '../../core/api/hooks/event-report/useGetEventReportsByType';

interface ICabinEventSubmissions {
  hours?: number;
  statuses?: EventFormStatus[];
  isOwner?: boolean;
  pageSize?: number;
  readonly?: boolean;
}
function CabinEventList({ hours = 0, statuses = [], isOwner = false, pageSize = 25, readonly = false }: ICabinEventSubmissions): JSX.Element {
  const reports = useGetEventReportsByType({
    reportType: ReportType.CabinEventReport,
    hours,
    statuses,
    isOwner,
  });
  if (reports?.isLoading) {
    return (
      <LinearProgress />
    );
  }

  return (
    <CabinFormsDataGrid
      data={reports}
      reportType="cabin-event"
      areSubmissions
      readOnly={readonly}
      pageSize={pageSize}
    />
  );
}

export default CabinEventList;
